import { useMachine } from 'lib/hooks/useMachine';
import { useProgramEventDisplayState } from 'lib/hooks/useProgramEventDisplayState';
import { useRealTimeData } from './useRealTimeData';
import { useInitialData } from './useInitialData';
import { useAnnotations } from './useAnnotations';
import { useSetupData } from './useSetupData';
import { useWorkflowWatcher } from './useWorkflowWatcher';
import { useFAIData } from './useFAIData';
// import { useStreamReader } from './useStreamReader';

const useData = () => {
  useMachine();
  useAnnotations();
  useRealTimeData();
  useSetupData();
  useWorkflowWatcher();
  useFAIData();
  // useStreamReader(); //TODO (Paul): Make a new StreamReader (Nats Client Consumer)
  useProgramEventDisplayState();
  const { refetch } = useInitialData();

  return { refetch };
};

export { useData };
